
<app-global-alert></app-global-alert>
<router-outlet></router-outlet>
